import { StyleSheet } from 'react-native';
import { SUBHEADING_SIZE, NORMAL_SIZE } from '../../../shared/constants/SizeConstants';
import {
  BG_COLOR,
  GREY_COLOR,
  SECONDARY_DARK_COLOR, BLACK,
  WHITE_COLOR, BLACK_COLOR,
} from '../../../shared/constants/ColorConstants';

export const styless = StyleSheet.create({
  modalWrapper: {
    backgroundColor: 'white',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  forgetModal: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: BG_COLOR,
    borderRadius: 5,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.5,
    shadowColor: 'black',
    shadowRadius: 5,
    elevation: 5,
  },
  modalHeader: {
    justifyContent: 'center',
    alignItems: 'center',
    height: 50,
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
    alignSelf: 'stretch',
    backgroundColor: SECONDARY_DARK_COLOR,
  },
  headingText: {
    fontWeight: 'bold',
    fontSize: SUBHEADING_SIZE,
    color: BLACK,
  },
  subHeadingText: {
    fontSize: NORMAL_SIZE,
    color: GREY_COLOR,
    marginBottom: 20,
    textAlign: 'center',
  },
  modalContainer: {
    alignSelf: 'stretch',
    padding: 20,
  },
  cancelBtnWrapper: {
    position: 'absolute',
    right: 15,
    top: 15,
    bottom: 0,
  },
  cancelIcon: {
    color: WHITE_COLOR,
    fontSize: 30,
  },
  textInput: {
    height: 44,
    width: '100%',
    color: BLACK_COLOR,
    fontSize: 14,
    padding: 12,
    backgroundColor: 'rgb(241, 242, 243)',
    borderRadius: 7,
  },
});
